import Header from '../Header/Header';
import Footer from '../Footer';
import BlogArchive from '../BLogArchive/BlogArchive';

const BlogArchivePage = () => {
  return (
    <>
      <Header logoColor="dark" />

      <main>
        <BlogArchive />
      </main>

      <Footer />
    </>
  );
};

export default BlogArchivePage;
